export enum LanguageShortEnum {
  Arabic = "Arabic",
  Chinese = "Chinese",
  English = "English",
  French = "French",
  German = "German",
  Hindi = "Hindi",
  Italian = "Italian",
  Japanese = "Japanese",
  Korean = "Korean",
  Portuguese = "Portuguese",
  Russian = "Russian",
  Spanish = "Spanish",
  Turkish = "Turkish",
}

export const languageShortsList = [
  LanguageShortEnum.Arabic,
  LanguageShortEnum.Chinese,
  LanguageShortEnum.English,
  LanguageShortEnum.French,
  LanguageShortEnum.German,
  LanguageShortEnum.Hindi,
  LanguageShortEnum.Italian,
  LanguageShortEnum.Japanese,
  LanguageShortEnum.Korean,
  LanguageShortEnum.Portuguese,
  LanguageShortEnum.Russian,
  LanguageShortEnum.Spanish,
  LanguageShortEnum.Turkish,
];
